module.exports = __webpack_public_path__ + "static/media/nav-icon.21fd1797.svg";